<div class="create-category">
    <mat-card-title class="mat-display-1">
        <span>Kategorie erstellen</span>
    </mat-card-title>
    <div class="form">
        <mat-card>
            <mat-card-content>
                <div class="new-form">
                    <form [formGroup]="projectCategoryForm" (ngSubmit)="submitForm()">
                        <div class="mb-2">  
                            <div class="title1">
                                <span class="projName">Name</span>
                                <div class="subtitle1">
                                    <input class="inputTitle" formControlName="name" label="Ihr Name hier"
                                        placeholder="Ihr Name hier">
                                </div>
                            </div>
                            <span class="note">Mindestens 4 Zeichen</span>
                        </div>
                        <div class="mb-2">  
                            <div class="title1">
                                <span class="projName">Description</span>
                                <div class="subtitle1">
                                    <textarea class="inputTitle" formControlName="description" label="Ihr Name hier"
                                        placeholder="Ihr Name hier"  cols="30" rows="10"></textarea>
                                </div>
                            </div>
                            <span class="note">Mindestens 10 Zeichen</span>
                        </div>
                       <!--  <div>
                            <mat-form-field>
                                <mat-label>Name</mat-label>
                                <input matInput formControlName="name" placeholder="Ihr Name hier">
                                <mat-hint align="end">Mindestens 4 Zeichen</mat-hint>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>Description</mat-label>
                                <textarea matInput formControlName="description" cols="30" rows="10"></textarea>
                                <mat-hint align="end">Min 10 Zeichen</mat-hint>
                            </mat-form-field>
                      </div> -->
        
                        <mat-card-actions>
                            <button
                                mat-raised-button
                                color="primary"
                                [disabled]="projectCategoryForm.invalid">
                                Speichern
                            </button>
                        </mat-card-actions>
                    </form>
                </div>               
                
            </mat-card-content>
        </mat-card>
    </div>
</div>
